"use client";

import {JSX} from "react";

import {useTranslation} from "@/shared/i18n";

import "./styles/rating-breakdown.scss";

interface RatingBreakdownProps {
    totalReviews: number;
    breakdown: {
        fiveStar: number;
        fourStar: number;
        threeStar: number;
        twoStar: number;
        oneStar: number;
    };
    className?: string;
}

export function RatingBreakdown({totalReviews, breakdown, className = ""}: RatingBreakdownProps): JSX.Element {
    const {t} = useTranslation("reviews");

    // Calculate percentages
    const calculatePercentage = (count: number): number => {
        if (totalReviews === 0) return 0;
        return Math.round((count / totalReviews) * 100);
    };

    const ratings = [
        {stars: 5, count: breakdown.fiveStar},
        {stars: 4, count: breakdown.fourStar},
        {stars: 3, count: breakdown.threeStar},
        {stars: 2, count: breakdown.twoStar},
        {stars: 1, count: breakdown.oneStar},
    ];

    return (
        <div className={`rating-breakdown ${className}`}>
            <div className="rating-breakdown__header">
                <span className="rating-breakdown__total">{t("count", {count: totalReviews})}</span>
            </div>

            <div className="rating-breakdown__list">
                {ratings.map((rating) => {
                    const percentage = calculatePercentage(rating.count);

                    return (
                        <div key={rating.stars} className="rating-breakdown__item">
                            <span className="rating-breakdown__label">{t("star", {count: rating.stars})}</span>

                            <div className="rating-breakdown__bar-container">
                                <div className="rating-breakdown__bar" style={{"--percentage": `${percentage}%`} as React.CSSProperties} />
                            </div>

                            <span className="rating-breakdown__percentage">{percentage}%</span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
